module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-star-599278a9.svg";